export default [
  { label: 'Partnership', value: 'Partnership' },
  { label: 'Incorporation', value: 'Incorporation' },
  { label: 'NGO', value: 'NGO' }
];
